import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { GiPodium } from "react-icons/gi";

// Menú lateral del diseño Clásico (lobby plano), compartido por el lobby y el historial.
const COPY = {
  es: {
    play: "Jugar",
    learn: "Aprender",
    tournaments: "Torneos",
    championship: "Campeonato",
    watch: "Ver partidos",
    friends: "Amigos",
    mine: "MI XIMA",
    stats: "Estadísticas",
    history: "Historial",
    design: "Diseñar tablero",
    store: "Tienda",
    premium: "Premium",
    settings: "Ajustes",
    support: "Soporte",
    admin: "Admin",
    logout: "Cerrar sesión",
  },
  en: {
    play: "Play",
    learn: "Learn",
    tournaments: "Tournaments",
    championship: "Championship",
    watch: "Watch games",
    friends: "Friends",
    mine: "MY XIMA",
    stats: "Statistics",
    history: "History",
    design: "Design board",
    store: "Store",
    premium: "Premium",
    settings: "Settings",
    support: "Support",
    admin: "Admin",
    logout: "Log out",
  },
};

// Acciones por ruta, para pantallas que no son el lobby.
export const useModernRouteActions = () => {
  const navigate = useNavigate();
  const outletContext = useOutletContext() || {};
  return {
    play: () => navigate("/game/lobby"),
    learn: () => navigate("/game/learn?fromLobbySource=learn"),
    tournaments: () => navigate("/game/play"),
    championship: () => navigate("/game/championship"),
    watch: () => navigate("/game/spectate?fromLobbySource=spectate"),
    friends: () => navigate("/game/friends?fromLobbySource=friends"),
    stats: () => navigate("/game/stats"),
    history: () => navigate("/game/history"),
    design: () => navigate("/game/design"),
    store: () => {
      outletContext.markSidebarBadgeSeen?.("store");
      navigate("/game/store?fromLobbySource=store");
    },
    premium: () => navigate("/game/store?fromLobbySource=store"),
    settings: () => navigate("/game/settings?fromLobbySource=settings"),
    support: () => {
      outletContext.markSidebarBadgeSeen?.("donate");
      navigate("/game/support");
    },
    admin: () => navigate("/game?tab=admin"),
    language: () => navigate("/game/settings?section=language&fromLobbySource=settings"),
    logout: () => outletContext.onLogout?.(),
  };
};

const ModernSidebar = ({ language = "es", active = "play", badges = {}, isAdmin = false, actions = {} }) => {
  const copy = COPY[language] || (language === "es" ? COPY.es : COPY.en);
  const item = (id, icon, extra = {}) => ({ id, icon, label: copy[id], onClick: actions[id], ...extra });
  const menu = [
    item("play", "🎲"),
    item("learn", "📖", { badge: badges.learn }),
    item("tournaments", "🏆", { badge: badges.tournaments }),
    item("championship", <GiPodium />, { badge: badges.championship }),
    item("watch", "📺", { badge: badges.watch }),
    item("friends", "👥", { badge: badges.friends }),
  ];
  const mine = [
    item("stats", "📊", { badge: badges.stats }),
    item("history", "🕘", { badge: badges.history }),
    item("design", "🎨"),
    item("store", "🛍️", { badge: badges.store }),
    item("premium", "💎"),
  ];
  const bottom = [
    item("settings", "⚙️"),
    item("support", "🛟", { badge: isAdmin ? badges.support : 0 }),
    ...(isAdmin ? [item("admin", "🛡️", { badge: badges.admin })] : []),
    item("logout", "↩", { plain: true }),
  ];
  const renderItem = (entry) => (
    <button
      key={entry.id}
      type="button"
      className={`xlm-nav-item${entry.id === active ? " is-active" : ""}${entry.plain ? " is-plain" : ""}`}
      onClick={entry.onClick}
    >
      <span className="xlm-nav-icon" aria-hidden="true">{entry.icon}</span>
      <span className="xlm-nav-label">{entry.label}</span>
      {Number(entry.badge) > 0 ? (
        <span className="xlm-nav-badge">{Number(entry.badge) > 999 ? "999+" : Number(entry.badge)}</span>
      ) : null}
    </button>
  );
  return (
    <aside className="xlm-sidebar">
      <div className="xlm-logo">XIMA</div>
      <nav className="xlm-nav">
        {menu.map(renderItem)}
        <div className="xlm-nav-section">{copy.mine}</div>
        {mine.map(renderItem)}
      </nav>
      <nav className="xlm-nav xlm-nav-bottom">{bottom.map(renderItem)}</nav>
    </aside>
  );
};

export default ModernSidebar;
